import { render, staticRenderFns } from "./ProfileChangeSettings.vue?vue&type=template&id=22fdf43c&scoped=true"
import script from "./ProfileChangeSettings.vue?vue&type=script&lang=js"
export * from "./ProfileChangeSettings.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeSettings.vue?vue&type=style&index=0&id=22fdf43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fdf43c",
  null
  
)

export default component.exports